import {
  RiArticleFill,
  RiArticleLine,
  RiDashboardLine,
  RiBarChartBoxFill,
  RiBarChartBoxLine,
  RiComputerFill,
  RiComputerLine,
  RiToolsFill,
  RiToolsLine,
  RiShiningFill,
  RiShiningLine,
  RiInputField,
  RiAdminFill,
  RiSettings5Fill,
  RiSettings5Line,
  RiApps2Line,
  RiCpuFill,
  RiAlarmWarningFill,
  RiAlarmWarningLine,
  RiWirelessChargingFill,
  RiErrorWarningFill,
  RiRouterFill,
  RiRouterLine,
  RiDeviceFill,
  RiDeviceLine,
  RiPriceTag3Line,
  RiRfidLine,
} from '@remixicon/react';



// Only the icons the menu API currently references need an entry here —
// anything unmapped (a new display_icon added on the backend, a typo, a
// null value) safely falls back to `default` instead of throwing.
const MENU_ICONS = {
  dashboard_icon: { filled: RiBarChartBoxFill, line: RiBarChartBoxLine },
  monitoring_icon: { filled: RiComputerFill, line: RiComputerLine },
  configuration_icon: { filled: RiToolsFill, line: RiToolsLine },
  catalog_icon: { filled: RiShiningFill, line: RiShiningLine },
  metadata_icon: { filled: RiInputField, line: RiInputField },
  administration_icon: { filled: RiAdminFill, line: RiAdminFill },
  settings_icon: { filled: RiSettings5Fill, line: RiSettings5Line },
  services_icon: { filled: RiDashboardLine, line: RiDashboardLine },
  logs_icon: { filled: RiArticleFill, line: RiArticleLine },
  system_icon: { filled: RiCpuFill, line: RiCpuFill },
  alerts_icon: { filled: RiAlarmWarningFill, line: RiAlarmWarningLine },
  tracking_icon: { filled: RiWirelessChargingFill, line: RiWirelessChargingFill },
  events_icon: { filled: RiErrorWarningFill, line: RiErrorWarningFill },
  gateways_icon: { filled: RiRouterFill, line: RiRouterLine },
  devices_icon: { filled: RiDeviceFill, line: RiDeviceLine },
  esl_management_icon: { filled: RiPriceTag3Line, line: RiPriceTag3Line },
  rfid_icon: { filled: RiRfidLine, line: RiRfidLine },


  default: { filled: RiApps2Line, line: RiApps2Line },

  // 
  // 
};

export const getMenuIcon = (displayIcon) => MENU_ICONS[displayIcon] ?? MENU_ICONS.default;
